import { IconSearch } from "@tabler/icons-react";
import { Button, Card, DatePickerInput, Group, Heading, Input, Select, Stack, Text } from "@/components/ui";
import { parseIso, formatIso } from "@/features/datos-generales/utils/iso-date";
import type { FiltrosHistorico } from "../services/historico.api";

/** Valores en edición de la barra de filtros · se aplican al click en Buscar. */
export interface FiltrosEnEdicion {
  desde: string;
  hasta: string;
  rfc: string;
  acreedor: string;
  organizacionId: string;
  clasificacion: string;
}

/**
 * Barra de filtros del Histórico (spec §7.1) · el periodo se etiqueta
 * "Periodo de la solicitud" (RN-02 · es la fecha de la solicitud, no la de
 * carga del archivo) y los combos ya vienen recortados a lo visible (RN-01).
 * Los filtros aplican al click en Buscar, no al tipear.
 */
export function HistoricoFiltrosCard({
  combos,
  valores,
  onChange,
  onBuscar,
  buscando,
}: {
  combos: FiltrosHistorico;
  valores: FiltrosEnEdicion;
  onChange: (v: FiltrosEnEdicion) => void;
  onBuscar: () => void;
  buscando: boolean;
}) {
  const set = (patch: Partial<FiltrosEnEdicion>) => onChange({ ...valores, ...patch });

  return (
    <Card padding="lg">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onBuscar();
        }}
      >
        <Stack gap="md">
          <div>
            <Heading order={5}>Filtros</Heading>
            <Text size="sm" c="dimmed" className="mt-0.5">
              El periodo corresponde a la fecha de la solicitud de pago, no a la fecha de carga
              del archivo.
            </Text>
          </div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            <DatePickerInput
              label="Periodo de la solicitud · del"
              placeholder="Inicio del periodo"
              clearable
              value={parseIso(valores.desde)}
              onChange={(d) => set({ desde: formatIso(d) })}
            />
            <DatePickerInput
              label="Periodo de la solicitud · al"
              placeholder="Fin del periodo"
              clearable
              value={parseIso(valores.hasta)}
              onChange={(d) => set({ hasta: formatIso(d) })}
            />
            <Select
              label="Sociedad"
              placeholder="Todas las visibles"
              options={[{ value: "", label: "Todas las visibles" }, ...combos.sociedades]}
              value={valores.organizacionId}
              onValueChange={(v) => set({ organizacionId: v })}
              searchable
            />
            <Input
              label="RFC del proveedor"
              placeholder="ej. NSN120716Q96"
              value={valores.rfc}
              onChange={(e) => set({ rfc: e.currentTarget.value.toUpperCase() })}
              maxLength={13}
            />
            <Input
              label="Número de acreedor"
              placeholder="ej. 10016"
              value={valores.acreedor}
              onChange={(e) => set({ acreedor: e.currentTarget.value })}
              maxLength={20}
            />
            <Select
              label="Clasificación"
              placeholder="Todas"
              options={[{ value: "", label: "Todas" }, ...combos.clasificaciones]}
              value={valores.clasificacion}
              onValueChange={(v) => set({ clasificacion: v })}
              searchable
            />
          </div>
          <Group justify="flex-end">
            <Button type="submit" leftSection={<IconSearch size={16} stroke={1.7} />} loading={buscando}>
              Buscar
            </Button>
          </Group>
        </Stack>
      </form>
    </Card>
  );
}
